import Cookies from "js-cookie"
import hash from "object-hash"
import {GetBagCallback, MasIdUpdated, RequestMasId} from "@next/eventservice"
import logger from "@next/core-logger"
import uuid from "uuid/v1"
import {MutableRefObject} from "react"
import {MASID_COOKIE_NAME, UCM_ONSITE_CONSENT} from "../../config/constants"
import {getRpId} from "../../utils/getRpId"
import {getPrsMasId} from "../../api/personalizationRetrievalService"

const getBagCallbackESB = new GetBagCallback()
const masIdUpdated = new MasIdUpdated()
const requestMasId = new RequestMasId()

/**
 * Upon /bag/get call completion, evaluates whether MASId cookie is updated and fires @type {MasIdUpdated} event
 * @param prevHash previousHash for the MASId cookie value
 * @param setPrevHash callback to update the MASId cookie hash
 * @returns @type {SubscribeToEvent}
 */
export const SubscribeToMasIdUpdatedEvent = (
    prevHash: MutableRefObject<string | null>,
    setPrevHash: (hashToUpdate) => void,
) => {
    return getBagCallbackESB.subscribe(evt => {
        requestMasId.publish()
        const cookieValue = Cookies.get(MASID_COOKIE_NAME) || null
        if (!cookieValue) return
        const previousHash = prevHash?.current
        const newHash: string = hash(cookieValue) as string
        const valueHasChanged = previousHash !== newHash
        if (!valueHasChanged) return

        setPrevHash(newHash)

        masIdUpdated.publish({
            eventId: uuid(),
            originatingEventId: evt.eventId || null,
            prevHash: previousHash,
            newHash,
            value: cookieValue,
            timestamp: new Date().toISOString(),
            originatingFunction: "header/bagget",
        })
    })
}

export const SubscribeToRequestMasId = (
    isPrsEnabled: boolean,
    realm: string,
    territory: string,
    language: string,
    siteUrl: string,
    firstName: string,
    isUcmEnabled: boolean,
) => {
    if (!isPrsEnabled) return
    try {
        requestMasId.subscribe(() => {
            const rpid = getRpId()
            const onsiteConsent = Cookies.get(UCM_ONSITE_CONSENT) || ""

            if (!rpid || (onsiteConsent !== true.toString() && isUcmEnabled)) return

            const masIdOnCookie = Cookies.get(MASID_COOKIE_NAME) || ""
            const previousHash = hash(masIdOnCookie) as string
            getPrsMasId(rpid, realm, territory, language, siteUrl, firstName)
                .then(masidFromPrs => {
                    if (!masidFromPrs) return
                    const newHash: string = hash(masidFromPrs) as string
                    if (previousHash !== newHash) {
                        masIdUpdated.publish({
                            eventId: uuid(),
                            originatingEventId: null,
                            prevHash: previousHash,
                            newHash,
                            value: masidFromPrs as string,
                            timestamp: new Date().toISOString(),
                            originatingFunction: "header/prs",
                        })
                    }
                })
                .catch(err => {
                    logger.error(err)
                })
        })
    } catch (error) {
        logger.error(error)
    }
}
